/* RESPONSIBLE TEAM: team-ai-agent */
import EscalationController from 'embercom/controllers/apps/app/automation/fin-ai-agent/escalation';

export default class AutomationFinAIAgentEcommerceEscalationController extends EscalationController {}
